import React from 'react';
import PropTypes from 'prop-types';
import Row from './Row';

const RecentStakesLayout = ({ data }) => {
    const sortHorsesByYear = () => {
        const sortedHorses = {};
        data.forEach((horse) => {
            const monthYear = horse.monthYear;

            if (!Object.prototype.hasOwnProperty.call(sortedHorses, monthYear)) {
                sortedHorses[monthYear] = [];
            }

            sortedHorses[monthYear].push(horse);
        });
        return sortedHorses;
    };

    const sortedHorseData = sortHorsesByYear();

    return (
        <div className="hp-recentStakesPerformers__container__content">
            {
                Object.keys(sortedHorseData).map(year =>
                    <Row key={year} horseList={sortedHorseData[year]} rowYear={year} />
                )
            }
        </div>
    );
};

RecentStakesLayout.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
};

export default RecentStakesLayout;



// WEBPACK FOOTER //
// ./src/js/horse/recentStakesPerformers/components/RecentStakesLayout.jsx